module.exports = __webpack_public_path__ + "img/wxcode.61c7def3.jpg";